module.exports = __webpack_public_path__ + "img/timelapse-video-max-poster.3b12dd3.jpg";